import type { FAQItem } from "@/pages/landingPage/components";
import { HUB_CRUMB, SITE_URL, TOOLS } from "./constants";

export const PATH = HUB_CRUMB.path;
// Sem o sufixo "| Fidexa": o titleTemplate de src/App.tsx acrescenta.
export const TITLE = "Ferramentas Grátis para Crediário de Lojas";
export const DESCRIPTION =
  "Ferramentas grátis para lojas que vendem no crediário próprio: gere carnê em PDF, simule parcelas com juros e calcule quanto a inadimplência custa à loja.";

export const TRAIL = [HUB_CRUMB];

export const COLLECTION = {
  "@context": "https://schema.org",
  "@type": "CollectionPage",
  name: TITLE,
  url: `${SITE_URL}${PATH}`,
  description: DESCRIPTION,
  inLanguage: "pt-BR",
  mainEntity: {
    "@type": "ItemList",
    itemListElement: TOOLS.map((tool, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: tool.name,
      url: `${SITE_URL}${tool.path}`,
    })),
  },
};

export const FAQ_ITEMS: FAQItem[] = [
  {
    question: "As ferramentas da Fidexa são pagas?",
    answer:
      "Não. O gerador de carnê, o simulador de crediário e a calculadora de inadimplência são gratuitos e funcionam direto no navegador, sem instalar nada.",
  },
  {
    question: "Preciso criar conta para usar as ferramentas?",
    answer:
      "Não. Nenhuma ferramenta pede cadastro, e os dados digitados ficam só no seu navegador. A conta na Fidexa só é necessária para automatizar a cobrança do crediário pelo WhatsApp.",
  },
  {
    question: "Para que tipo de loja as ferramentas foram feitas?",
    answer:
      "Para o varejo que vende no crediário próprio, como lojas de calçados, roupas e móveis, da loja única à rede com várias unidades. As contas seguem o que o lojista usa no balcão: parcela fixa, juros ao mês e carnê com canhoto.",
  },
];
